import { ImgHTMLAttributes, useEffect, useState } from "react";

type AppImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> & {
  src?: string;
  fallbackSrc?: string;
  alt: string;
  hideOnError?: boolean;
};

export function AppImage({
  src,
  fallbackSrc,
  alt,
  className,
  hideOnError = true,
  ...props
}: AppImageProps) {
  const [currentSrc, setCurrentSrc] = useState(src || fallbackSrc || "");
  const [hasTriedFallback, setHasTriedFallback] = useState(false);

  useEffect(() => {
    setCurrentSrc(src || fallbackSrc || "");
    setHasTriedFallback(false);
  }, [fallbackSrc, src]);

  if (!currentSrc) {
    return null;
  }

  return (
    <img
      {...props}
      src={currentSrc}
      alt={alt}
      className={className}
      onError={() => {
        if (!hasTriedFallback && fallbackSrc && currentSrc !== fallbackSrc) {
          setCurrentSrc(fallbackSrc);
          setHasTriedFallback(true);
          return;
        }

        if (hideOnError) {
          setCurrentSrc("");
        }
      }}
    />
  );
}
